import { useCallback, useState } from 'react';
import DraggableTile from 'InpageEditorUI/components/sidebar/add/DraggableTile';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import { setSelectedUpgradableModule } from 'ContentEditorUI/redux/actions/appActions';
import { useDispatch } from 'react-redux';
import { MODULES_BY_PATH_MARKED_AS_NEW } from 'ContentEditorUI/redux/constants';
import { PATAGONIA_ADD_PANEL_SUB_CATEGORIES } from 'ContentEditorUI/constants/Sidebar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TRUNCATED_TILE_NUM = 8;
const PATAGONIA_NUM_TILE_COLUMNS = 4;
const EmptyTile = ({
  type
}) => {
  return /*#__PURE__*/_jsx(DraggableTile, {
    isDraggable: false,
    hideTooltips: true,
    type: type,
    schema: {
      displayName: ''
    },
    style: {
      visibility: 'hidden'
    }
  });
};
const PQLTile = ({
  pqlId,
  moduleSchema,
  type,
  sidebarIframeBody
}) => {
  const dispatch = useDispatch();
  return /*#__PURE__*/_jsx(DraggableTile, {
    isDraggable: false,
    schema: moduleSchema,
    type: type,
    sidebarIframeBody: sidebarIframeBody,
    hideTooltips: false,
    useLockedRibbon: true,
    onMouseDown: () => {
      dispatch(setSelectedUpgradableModule(pqlId));
    }
  });
};
const useTiles = ({
  collection,
  type,
  upgradableModules = []
}) => {
  const isAllModules = type === 'allModules' || type === PATAGONIA_ADD_PANEL_SUB_CATEGORIES.MODULES.ALL;
  function getInitialModuleState(modules, endIndex) {
    const shouldTruncate = !isAllModules;
    return shouldTruncate ? modules.slice(0, endIndex) : modules;
  }
  const [visibleCollection, setVisibleCollection] = useState(getInitialModuleState(collection, TRUNCATED_TILE_NUM));
  const [visibleUpgradableModules, setVisibleUpgradableModules] = useState(getInitialModuleState(upgradableModules, TRUNCATED_TILE_NUM - visibleCollection.length));
  const handleAddMoreClick = useCallback(() => {
    setVisibleCollection(collection);
    setVisibleUpgradableModules(upgradableModules);
  }, [collection, upgradableModules]);
  const totalTiles = collection.length + upgradableModules.length;
  const totalVisibleTiles = visibleCollection.length + visibleUpgradableModules.length;
  const shouldRenderShowMore = totalTiles > totalVisibleTiles;

  // Solve this problem: https://stackoverflow.com/questions/34331102/how-to-display-wrapping-flex-items-as-space-between-with-last-row-aligned-left
  const tileColumns = PATAGONIA_NUM_TILE_COLUMNS;
  const remainingTiles = totalVisibleTiles % tileColumns;
  const totalEmptyTilesNeeded = remainingTiles > 0 && !isAllModules ? tileColumns - remainingTiles : 0;
  return {
    handleAddMoreClick,
    shouldRenderShowMore,
    totalEmptyTilesNeeded,
    visibleCollection,
    visibleUpgradableModules
  };
};
export const TileList = ({
  hideTooltips,
  collection,
  className,
  onDragStart,
  onDragEnd,
  type,
  sidebarIframeBody,
  upgradableModules = []
}) => {
  const {
    handleAddMoreClick,
    shouldRenderShowMore,
    totalEmptyTilesNeeded,
    visibleCollection,
    visibleUpgradableModules
  } = useTiles({
    collection,
    type,
    upgradableModules
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("ul", {
      className: `add-widget-baymax-list ${className}`,
      "data-test-id": "common-widgets-list",
      children: [visibleCollection.map((schema, i) => {
        const useNewRibbon = MODULES_BY_PATH_MARKED_AS_NEW.includes(schema.path);
        return /*#__PURE__*/_jsx(DraggableTile, {
          hideTooltips: hideTooltips,
          sidebarIframeBody: sidebarIframeBody,
          onDragEnd: onDragEnd,
          onDragStart: onDragStart,
          type: type,
          schema: schema,
          useNewRibbon: useNewRibbon
        }, i);
      }), visibleUpgradableModules.map((schema, i) => /*#__PURE__*/_jsx(PQLTile, {
        pqlId: schema.pqlId,
        moduleSchema: schema.moduleSchema,
        type: type,
        sidebarIframeBody: sidebarIframeBody
      }, i + collection.length)), totalEmptyTilesNeeded > 0 && Array(totalEmptyTilesNeeded).fill(0).map((_el, index) => /*#__PURE__*/_jsx(EmptyTile, {
        type: type
      }, index))]
    }), shouldRenderShowMore && /*#__PURE__*/_jsxs(UIButton, {
      onClick: handleAddMoreClick,
      use: "transparent",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "add"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "addModule.showMore"
      })]
    })]
  });
};
export const renderLazyTileList = ({
  hideTooltips,
  collection,
  className,
  onDragStart,
  onDragEnd,
  type,
  sidebarIframeBody,
  shouldRenderTourStep,
  upgradableModules
}) => () => /*#__PURE__*/_jsx(TileList, {
  hideTooltips: hideTooltips,
  collection: collection,
  className: className,
  onDragStart: onDragStart,
  onDragEnd: onDragEnd,
  type: type,
  sidebarIframeBody: sidebarIframeBody,
  shouldRenderTourStep: shouldRenderTourStep,
  upgradableModules: upgradableModules
});